var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm.item.contractPartnerName
      ? _c("b", [
          _vm._v("\n    " + _vm._s(_vm.item.contractPartnerName) + "\n  ")
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.item.id !== -1 &&
    _vm.item.contractPartnerName !== "Neuen Vertragspartner anlegen"
      ? _c("address", [
          _c("div", [
            _vm._v(
              _vm._s(_vm.item.street) + " " + _vm._s(_vm.item.streetNumber)
            )
          ]),
          _vm._v(" "),
          _c("div", [
            _vm._v(_vm._s(_vm.item.postalCode + ", " + _vm.item.city))
          ])
        ])
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5910b2fc", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5910b2fc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/contracts/ContractPartnerTemplate.vue
// module id = nt3Z
// module chunks = 1